import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class RedirectService {
  go(url: string): void {
    window.location.assign(url);
  }
}
